import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  agencies: null,
  agencyCount: 0,
  totalAgencies: null,
};

const agencyListingSlice = createSlice({
  name: "agencyListing",
  initialState,
  reducers: {
    fetchAgencies(state, action) {
      state.loading = true;
    },
    fetchAgenciesSuccess(state, action) {
      state.agencies = action.payload;
      state.agencyCount = action.payload.count;
      state.loading = false;
    },
    fetchAgenciesFailure(state, action) {
      state.loading = false;
    },
    fetchTotalAgencies(state, action) {
      state.loading = true;
    },
    fetchTotalAgenciesSuccess(state, action) {
      state.totalAgencies = action.payload;
      state.loading = false;
    },
    fetchTotalAgenciesFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = agencyListingSlice;
